import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../../../../../../Utils/DateUtils';
import { AppConstant } from '../../../../../../Assests/AppConstant';
import { getUserSelector } from '../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import { toast } from 'react-toastify';
import { changeFormatWithoutTz, showAlert } from '../../../../../../Assests/Utility';
import { getWhMetaDataReducerSlice } from '../../../../../../../redux/reducers/reducerSlices/WhMetaDataReducerSlice';
import { fetchBreakListCommonFunc, fetchBreaksDocksListCommonFunc } from './Common/FetchBreakList';
import { fetchDockListCommonFunc } from '../DocksMeta/Common/FetchDockList';
import _ from 'lodash-es';
import WarehouseSearchSS from '../../../../../SuperWarehouse/Components/SearchWarehouse/WarehouseSearchSS';
import SSPopup from '../../../../../Common/Popup/SSPopup/SSPopup';
import BreaksMetaListSS from './BreaksMetaList/BreaksMetaListSS';
import CustomDropDownSS from '../../../../../Common/CustomDropDown/CustomDropDownSS';
import { useNavigate } from 'react-router-dom';
import { fetchTimeslotListCommonFunc } from '../DockDoorsForm/Common/FetchTimeslotsList';
import AutomaticCancelPopup from '../Common/AutomaticCancelPopup';
import './BreaksFormSS.css';

const BreaksMetaDataFormSS = (props) => {

    const { themeSelected, allowPermissionE = true, allowPermissionD = true, whObj } = props;
    const dispatch = useDispatch();
    const whMetaData = useSelector(getWhMetaDataReducerSlice);
    const { operationObj, whMetaDocksList, preCheckList, whMetaTimeslotList } = whMetaData;
    const user = useSelector(getUserSelector);
    const { cu_id } = user;
    const navigate = useNavigate();
    const firstUpdate = useRef(true);

    // today's date in YYYY-MM-DD for native input min attribute
    const todayStr = moment().format('YYYY-MM-DD');

    const initialInputs = {
        breaksForWhOrDock: 'Docks',
        IDDock: '',
        IDTimeslot: '',
        BreakStart: '',
        BreakEnd: '',
        // BreakStartDateTime / BreakEndDateTime are now YYYY-MM-DD strings (from native date input)
        BreakStartDateTime: '',
        BreakEndDateTime: '',
        Description: '',
        operational_days: null
    };

    const initialErrors = {
        IDDock: '',
        IDTimeslot: '',
        BreakStart: '',
        BreakEnd: '',
        BreakStartDateTime: '',
        BreakEndDateTime: '',
        Description: '',
        operational_days: ''
    };

    const initialDirty = {
        IDDock: false,
        IDTimeslot: false,
        BreakStart: false,
        BreakEnd: false,
        BreakStartDateTime: false,
        BreakEndDateTime: false,
        Description: false,
        operational_days: false
    };

    const [inputs, setInputs] = useState(initialInputs);
    const [errors, setErrors] = useState(initialErrors);
    const [dirty, setDirty] = useState(initialDirty);
    const [dateResetKey, setDateResetKey] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState({});
    const [searchStr, setSearchStr] = useState('');
    const [loading, setLoading] = useState(false);
    const [currentFilterSelected, setCurrentFilterSelected] = useState({ name: 'Docks' });
    const [isDockHidden, setIsDockHidden] = useState(false);
    const [isTimeSlotHidden, setIsTimeSlotHidden] = useState(true);
    const [showPreCheckModal, setShowPreCheckModal] = useState(false);
    const [showAutomaticCancelConfirmPopup, setShowAutomaticCancelConfirmPopup] = useState(false);
    const [pendingBreakData, setPendingBreakData] = useState(null);
    const [timeSlotOptions, setTimeSlotOptions] = useState([]);
    const [selectedID, setSelectedID] = useState(null);
    const [showAutoMassCancelNotification, setShowAutoMassCancelNotification] = useState(false);
    const [operationalDays, setOperationalDays] = useState({
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false
    });
    const [selectedDockData, setSelectedDockData] = useState(null);

    useEffect(() => {
        setLoading(false);
        setShowModal(false);
        fetchDockList();
        fetchTimeslotList();
        setShowAutoMassCancelNotification(false);
        dispatch({ type: sagaActions.UPDATE_PRE_CHECK_LIST, payload: [] });
    }, []);

    useEffect(() => {
        return () => {
            dispatch({ type: sagaActions.RESET_MASS_CANCEL_REASON });
        };
    }, []);

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        if (preCheckList.length > 0) {
            setShowModal(false);
            setLoading(false);
            const selectedDockId = pendingBreakData?.apiParams?.IDDock;
            const selectedDock = whMetaDocksList.find(dock => dock.ID === selectedDockId);
            if (selectedDock?.AppointmentCancelationType === 'AUTOMATIC') {
                setShowAutomaticCancelConfirmPopup(true);
            } else {
                setShowPreCheckModal(true);
            }
        }
    }, [preCheckList]);

    useEffect(() => {
        if (selectedID) {
            const list = whMetaTimeslotList && whMetaTimeslotList.length && whMetaTimeslotList.filter((el) => el.IDDock === selectedID);
            const finalList = list && list.length && list.map((el) => ({
                name: `${el.Name} - ${el.TimeSlotName}`,
                value: el.ID
            }));
            setTimeSlotOptions(finalList || []);
        }
    }, [whMetaTimeslotList, selectedID]);

    useEffect(() => {
        if (operationObj.type) {
            switch (operationObj.type) {
                case 'Add Break':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.smartScheduler.breaksForm.createBreakSuccess, showAutoMassCancelNotification);
                    } else {
                        if (operationObj?.message && operationObj?.message.includes('already added')) {
                            handleApiResponse(AppConstant.commonStrings.failure, AppConstant.smartScheduler.breaksForm.createDuplicateBreakFailure, showAutoMassCancelNotification);
                        } else {
                            handleApiResponse(AppConstant.commonStrings.failure, AppConstant.smartScheduler.breaksForm.createBreakFailure, showAutoMassCancelNotification);
                        }
                    }
                    break;
                case 'Edit Break':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.smartScheduler.breaksForm.updateBreakSuccess, showAutoMassCancelNotification);
                    } else {
                        if (operationObj?.message && operationObj?.message.includes('already added')) {
                            handleApiResponse(AppConstant.commonStrings.failure, AppConstant.smartScheduler.breaksForm.createDuplicateBreakFailure, showAutoMassCancelNotification);
                        } else {
                            handleApiResponse(AppConstant.commonStrings.failure, AppConstant.smartScheduler.breaksForm.createBreakFailure, showAutoMassCancelNotification);
                        }
                    }
                    break;
                case 'Update status':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.smartScheduler.breaksForm.updateBreakStatusSuccess, showAutoMassCancelNotification);
                    } else {
                        handleApiResponse(AppConstant.commonStrings.failure, AppConstant.smartScheduler.breaksForm.updateBreakStatusFailure, showAutoMassCancelNotification);
                    }
                    break;
                default:
            }
        }
    }, [operationObj]);

    const fetchTimeslotList = () => {
        let { apiParams, operationObj } = fetchTimeslotListCommonFunc(whObj);
        dispatch({ type: sagaActions.WAREHOUSE_META_TIMESLOT_ACTION, payload: apiParams, operationObj: operationObj });
    };

    const handleApiResponse = (result, message, showAutoMassCancelNotification) => {
        if (result === AppConstant.notifications.dataAddedSuccess) {
            showAlert(toast.TYPE.SUCCESS, message, themeSelected);
            setShowModal(false);
            resetForm();
            fetchBreaksList();
            if (showAutoMassCancelNotification) {
                showAlert(toast.TYPE.INFO, AppConstant.smartScheduler.leaves.massCancellationNotification, themeSelected);
                setShowAutoMassCancelNotification(false);
            }
        } else {
            showAlert(toast.TYPE.ERROR, message, themeSelected);
        }
        setLoading(false);
        dispatch({ type: sagaActions.RESET_SS_PO_OPERATION_OBJ });
    };

    const fetchDockList = () => {
        const { apiParams, operationObj } = fetchDockListCommonFunc(whObj);
        dispatch({ type: sagaActions.WAREHOUSE_META_DOCK_LIST_ACTION, payload: apiParams, operationObj: operationObj });
    };

    const fetchBreaksList = () => {
        if (currentFilterSelected.name === 'Warehouse') {
            const { apiParams, operationObj } = fetchBreakListCommonFunc(whObj);
            dispatch({ type: sagaActions.WAREHOUSE_META_BREAKS_LIST_ACTION, payload: apiParams, operationObj: operationObj });
        } else {
            fetchDocksBreaksList();
        }
    };

    const fetchDocksBreaksList = () => {
        const { apiParams, operationObj } = fetchBreaksDocksListCommonFunc(whObj, _.upperCase(currentFilterSelected?.name));
        dispatch({ type: sagaActions.WAREHOUSE_META_DOCKS_BREAKS_LIST_ACTION, payload: apiParams, operationObj: operationObj });
    };

    const resetForm = () => {
        setInputs(initialInputs);
        setEditData({});
        setSelectedID(null);
        setIsDockHidden(false);
        setIsTimeSlotHidden(true);
        setOperationalDays({
            sunday: false,
            monday: false,
tuesday: false,
            wednesday: false,
         thursday: false,
       friday: false,
      saturday: false
 });
     setSelectedDockData(null);
        setErrors(initialErrors);
 setDirty(initialDirty);
        setDateResetKey((k) => k + 1);
    };

    const editBreak = (data) => {
        fetchDockList();
        fetchTimeslotList();

        const breakType = data.IDTimeslot ? 'Timeslot' : 'Docks';
        const editData1 = {
            IDDockBreak: data.IDDockBreak || null,
            IDWHBreak: data.IDWHBreak || null,
            ID: data.IDDockBreak || data.IDWHBreak || data.ID || null,
            BreakStart: changeFormatWithoutTz(data.BreakStart, 'HH:mm'),
            BreakEnd: changeFormatWithoutTz(data.BreakEnd, 'HH:mm'),
            // Convert to YYYY-MM-DD string for native date input
            BreakStartDateTime: data.BreakStart ? moment(data.BreakStart).format('YYYY-MM-DD') : '',
            BreakEndDateTime: data.BreakEnd ? moment(data.BreakEnd).format('YYYY-MM-DD') : '',
            Description: data.Description,
            Status: data.Status,
            CreatedBy: cu_id,
            UpdatedBy: data.UpdatedBy,
            CRUDTYPE: 'U',
            breaksForWhOrDock: breakType,
            IDDock: data.IDDock || '',
            IDTimeslot: data.IDTimeslot || '',
            operational_days: {
                sunday: data.sunday || false,
                monday: data.monday || false,
                tuesday: data.tuesday || false,
                wednesday: data.wednesday || false,
                thursday: data.thursday || false,
                friday: data.friday || false,
                saturday: data.saturday || false
            }
        };

        setShowModal(true);
        setEditData(editData1);
        setInputs(editData1);
        setIsDockHidden(breakType === 'Timeslot');
        setIsTimeSlotHidden(breakType === 'Docks');
        if (data.IDDock) {
            setSelectedID(data.IDDock);
            const selectedDock = whMetaDocksList.find(dock => dock.ID === data.IDDock);
            if (selectedDock) {
                setSelectedDockData(selectedDock);
                const daysObj = {
                    sunday: data.sunday || false,
                    monday: data.monday || false,
                    tuesday: data.tuesday || false,
                    wednesday: data.wednesday || false,
                    thursday: data.thursday || false,
                    friday: data.friday || false,
                    saturday: data.saturday || false
                };
                setOperationalDays(daysObj);
            }
        }
    };

    const getDockList = () => {
        return whMetaDocksList && whMetaDocksList.length
            ? whMetaDocksList.map((ele) => {
                if (ele && ele.DockStatus) {
                    const opDays = {
                        sunday: ele.sunday,
                        monday: ele.monday,
                        tuesday: ele.tuesday,
                        wednesday: ele.wednesday,
                        thursday: ele.thursday,
                        friday: ele.friday,
                        saturday: ele.saturday
                    };
                    const dayAbbreviations = {
                        sunday: 'Sun', monday: 'Mon', tuesday: 'Tue',
                        wednesday: 'Wed', thursday: 'Thu', friday: 'Fri', saturday: 'Sat'
                    };
                    const activeDays = Object.keys(opDays).filter(d => opDays[d]).map(d => dayAbbreviations[d]);
                    const daysDisplay = activeDays.length > 0 ? activeDays.join(', ') : 'Non Operational';
                    return (
                        <option key={ele.ID} value={ele.ID}>
                            {ele.Name} ({daysDisplay})
                        </option>
                    );
                }
                return null;
            }).filter(Boolean)
            : [];
    };

    /**
     * Returns an object indicating which days of the week fall within
     * [startDate, endDate] (both as YYYY-MM-DD strings or Date objects).
     */
    const getDaysInRange = (startDate, endDate) => {
        if (!startDate || !endDate) return null;
        const start = moment(startDate).startOf('day');
        const end = moment(endDate).startOf('day');
        const dayDiff = end.diff(start, 'days');
        if (dayDiff < 0) return null;
        if (dayDiff >= 6) {
            return { sunday: true, monday: true, tuesday: true, wednesday: true, thursday: true, friday: true, saturday: true };
        }
        const result = { sunday: false, monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false };
        const dayNamesArr = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        let current = start.clone();
        while (current.isSameOrBefore(end, 'day')) {
            result[dayNamesArr[current.day()]] = true;
            current.add(1, 'day');
        }
        return result;
    };

    const resetOpDays = () => ({
        sunday: false, monday: false, tuesday: false,
        wednesday: false, thursday: false, friday: false, saturday: false
    });

    /**
     * Validates a YYYY-MM-DD string coming from a native <input type="date">.
     * @param {string} dateStr  - e.target.value ('' when invalid/incomplete)
     * @param {boolean} badInput - e.target.validity.badInput (true when user typed something but browser can't parse it)
     * @param {'start'|'end'} fieldRole - contextual role for past-date check
     * @param {string|null} minDateStr  - YYYY-MM-DD; if provided, dateStr must be >= minDateStr
     * @returns {string} error message, or '' when valid
     */
    const validateDateInput = (dateStr, badInput, fieldRole, minDateStr) => {
        // User typed something but the browser couldn't form a valid date
        // (covers invalid days like Feb 31, or incomplete entries)
        if (badInput && !dateStr) {
            return 'Please enter a valid date (MM/DD/YYYY)';
        }

        if (!dateStr) return '';

        // Check the year part has exactly 4 digits (rejects 6-digit years)
        const parts = dateStr.split('-');
        if (parts.length === 3) {
            const year = parts[0];
            if (year.length !== 4 || parseInt(year, 10) < 1000 || parseInt(year, 10) > 9999) {
                return 'Year must be a valid 4-digit year (e.g. 2025)';
            }

            // Validate calendar correctness: e.g. Feb 31 is invalid
            const month = parseInt(parts[1], 10);
            const day = parseInt(parts[2], 10);
            const dateObj = new Date(`${dateStr}T00:00:00`);
            if (
                isNaN(dateObj.getTime()) ||
                dateObj.getMonth() + 1 !== month ||
                dateObj.getDate() !== day
            ) {
                return `Invalid date: ${parts[1]}/${parts[2]}/${year} does not exist`;
            }
        }

        // Past-date check for the start date field
        if (fieldRole === 'start' && minDateStr && dateStr < minDateStr) {
            return 'Break Start Date cannot be a past date';
        }

        return '';
    };

    const handleChange = (data, name, validity) => {
        if (name === 'breaksForWhOrDock') {
            if (data === 'Warehouse') {
                setIsDockHidden(false);
                setIsTimeSlotHidden(false);
            } else if (data === 'Timeslot') {
                setIsTimeSlotHidden(false);
                setIsDockHidden(true);
            } else if (data === 'Docks') {
                setIsDockHidden(false);
                setIsTimeSlotHidden(true);
            }
        }

        if (name === 'IDDock') {
            setSelectedID(data);
            const selectedDock = whMetaDocksList.find(dock => dock.ID === data);
            if (selectedDock) {
                setSelectedDockData(selectedDock);
            } else {
                setSelectedDockData(null);
            }
            setOperationalDays(resetOpDays());
            setInputs((prevInputs) => ({ ...prevInputs, IDDock: data, operational_days: null }));
            return;
        }

        // BreakStartDateTime — YYYY-MM-DD string from native date input
        if (name === 'BreakStartDateTime') {
            const newStartStr = data; // 'YYYY-MM-DD' or ''
            const badInput = validity ? validity.badInput : false;
            const err = validateDateInput(newStartStr, badInput, 'start', todayStr);
            if (err) {
                setErrors((prev) => ({ ...prev, BreakStartDateTime: err }));
                setDirty((prev) => ({ ...prev, BreakStartDateTime: true }));
                setInputs((prev) => ({ ...prev, BreakStartDateTime: newStartStr, operational_days: null }));
                setOperationalDays(resetOpDays());
                return;
            }
            setOperationalDays(resetOpDays());
            // If end date is before new start, clear it
            if (inputs.BreakEndDateTime && newStartStr && inputs.BreakEndDateTime < newStartStr) {
                setInputs((prev) => ({ ...prev, BreakStartDateTime: newStartStr, BreakEndDateTime: '', operational_days: null }));
            } else {
                setInputs((prev) => ({ ...prev, BreakStartDateTime: newStartStr, operational_days: null }));
            }
            setErrors((prev) => ({ ...prev, BreakStartDateTime: '', BreakEndDateTime: '' }));
            return;
        }

        // BreakEndDateTime — YYYY-MM-DD string from native date input
        if (name === 'BreakEndDateTime') {
            const newEndStr = data; // 'YYYY-MM-DD' or ''
            const badInput = validity ? validity.badInput : false;
            const err = validateDateInput(newEndStr, badInput, 'end', null);
            if (err) {
                setErrors((prev) => ({ ...prev, BreakEndDateTime: err }));
                setDirty((prev) => ({ ...prev, BreakEndDateTime: true }));
                setInputs((prev) => ({ ...prev, BreakEndDateTime: newEndStr, operational_days: null }));
                setOperationalDays(resetOpDays());
                return;
            }
            // Validate end >= start
            if (inputs.BreakStartDateTime && newEndStr && newEndStr < inputs.BreakStartDateTime) {
                setErrors((prev) => ({ ...prev, BreakEndDateTime: 'End date must be on or after start date' }));
                setInputs((prev) => ({ ...prev, BreakEndDateTime: newEndStr, operational_days: null }));
                setOperationalDays(resetOpDays());
                return;
            }
            setOperationalDays(resetOpDays());
            setInputs((prev) => ({ ...prev, BreakEndDateTime: newEndStr, operational_days: null }));
            setErrors((prev) => ({ ...prev, BreakEndDateTime: '' }));
            return;
        }

        setInputs((prevInputs) => ({ ...prevInputs, [name]: data }));
    };

    const handleOperationalDays = (e) => {
        const { name, checked } = e.target;
        const updatedDays = { ...operationalDays, [name]: checked };
        setOperationalDays(updatedDays);
        setInputs((prevInputs) => ({ ...prevInputs, operational_days: updatedDays }));
    };

    const handleErrors = (name, validity) => {
        setDirty((prevDirty) => ({ ...prevDirty, [name]: true }));
        // For date fields, run inline validation on blur so field-level errors appear
        if (name === 'BreakStartDateTime' || name === 'BreakEndDateTime') {
            const currentVal = inputs[name] || '';
            const badInput = validity ? validity.badInput : false;
            const fieldRole = name === 'BreakStartDateTime' ? 'start' : 'end';
            const minDate = name === 'BreakStartDateTime' ? todayStr : null;
            const err = validateDateInput(currentVal, badInput, fieldRole, minDate);
            if (err) {
                setErrors((prev) => ({ ...prev, [name]: err }));
                return;
            }
            // Cross-field check on blur
            if (name === 'BreakEndDateTime' && inputs.BreakStartDateTime && currentVal && currentVal < inputs.BreakStartDateTime) {
                setErrors((prev) => ({ ...prev, BreakEndDateTime: 'End date must be on or after start date' }));
                return;
            }
        }
        validate(name);
    };

    function convertTimeToDate(timeString) {
        if (!timeString) return null;
        const [hours, minutes] = timeString.split(':').map(Number);
        const currentDate = new Date();
        currentDate.setHours(hours, minutes, 0, 0);
        return currentDate;
    }

    const generateTimeOptions = () => {
        const options = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 15) {
                const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
                options.push(timeString);
            }
        }
        return options;
    };

    const getFilteredEndTimes = () => {
        if (!inputs.BreakStart) return generateTimeOptions();
        const startTime = convertTimeToDate(inputs.BreakStart);
        const fifteenMinAfter = new Date(startTime.getTime() + 15 * 60000);
        const hours = fifteenMinAfter.getHours();
        const minutes = fifteenMinAfter.getMinutes();
        const minTimeAllowed = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        return generateTimeOptions().filter(time => time >= minTimeAllowed);
    };

    const validate = () => {
        let valid = true;
        let errorData = { ...initialErrors };

        // Validate Break Start Date
        if (!inputs.BreakStartDateTime) {
            errorData.BreakStartDateTime = errors.BreakStartDateTime || AppConstant.help.required;
            valid = false;
        } else {
            const startErr = validateDateInput(inputs.BreakStartDateTime, false, 'start', todayStr);
            if (startErr) {
                errorData.BreakStartDateTime = startErr;
                valid = false;
            }
        }

        // Validate Break End Date
        if (!inputs.BreakEndDateTime) {
            errorData.BreakEndDateTime = errors.BreakEndDateTime || AppConstant.help.required;
            valid = false;
        } else {
            const endErr = validateDateInput(inputs.BreakEndDateTime, false, 'end', null);
            if (endErr) {
                errorData.BreakEndDateTime = endErr;
                valid = false;
            }
        }

        // Validate start <= end (string comparison works for YYYY-MM-DD)
        if (inputs.BreakStartDateTime && inputs.BreakEndDateTime && !errorData.BreakStartDateTime && !errorData.BreakEndDateTime) {
            if (inputs.BreakEndDateTime < inputs.BreakStartDateTime) {
                errorData.BreakEndDateTime = 'End date must be on or after start date';
                valid = false;
            }
        }

        if (!inputs.BreakStart) {
            errorData.BreakStart = AppConstant.help.required;
            valid = false;
        }

        if (!inputs.BreakEnd) {
            errorData.BreakEnd = AppConstant.help.required;
            valid = false;
        }

        if (!inputs.Description) {
            errorData.Description = AppConstant.help.required;
            valid = false;
        }

        if (!isDockHidden && !inputs.IDDock) {
            errorData.IDDock = AppConstant.help.required;
            valid = false;
        }

        if (!isTimeSlotHidden && !inputs.IDTimeslot) {
            errorData.IDTimeslot = AppConstant.help.required;
            valid = false;
        }

        // Validate operational days selection when dock is selected
        if (!isDockHidden && inputs.IDDock) {
            if (inputs.BreakStartDateTime && inputs.BreakEndDateTime && selectedDockData) {
                const daysInRange = getDaysInRange(inputs.BreakStartDateTime, inputs.BreakEndDateTime);
                if (daysInRange) {
                    const dayNamesArr = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                    const hasValidDay = dayNamesArr.some(day => selectedDockData[day] && daysInRange[day]);
                    if (!hasValidDay) {
                        errorData.operational_days = 'Selected date range does not include any operational day';
                        valid = false;
                    }
                }
            }

            const hasSelectedDay = Object.values(operationalDays).some(day => day === true);
            if (!hasSelectedDay && valid) {
                errorData.operational_days = 'Please select at least one operational day';
                valid = false;
            }
        }

        // Validate time comparison
        if (inputs.BreakStart && inputs.BreakEnd) {
            const startTime = convertTimeToDate(inputs.BreakStart);
            const endTime = convertTimeToDate(inputs.BreakEnd);
            if (startTime && endTime) {
                const fifteenMinutesAfterStart = new Date(startTime.getTime() + 15 * 60000);
                if (endTime < fifteenMinutesAfterStart) {
                    errorData.BreakEnd = 'End time must be at least 15 minutes after start time';
                    valid = false;
                }
            }
        }

        setErrors(errorData);
        return valid;
    };

    const submitForm = () => {
        setDirty({
            IDDock: true, IDTimeslot: true, BreakStart: true, BreakEnd: true,
            BreakStartDateTime: true, BreakEndDateTime: true, Description: true, operational_days: true
        });
        if (validate()) {
            getSummitedFormData(inputs);
        }
    };

    const getFormFieldData = (data, name) => {
        handleChange(data, name);
    };

    const getOperationalDaysPayload = (data) => ({
        sunday: data.operational_days?.sunday || false,
        monday: data.operational_days?.monday || false,
        tuesday: data.operational_days?.tuesday || false,
        wednesday: data.operational_days?.wednesday || false,
        thursday: data.operational_days?.thursday || false,
        friday: data.operational_days?.friday || false,
        saturday: data.operational_days?.saturday || false
    });

    /** Combines BreakStartDateTime (YYYY-MM-DD string) + BreakStart (HH:mm) into ISO datetime string */
    const buildBreakStartDateTime = (data) => {
        if (!data.BreakStartDateTime || !data.BreakStart) return null;
        return `${data.BreakStartDateTime}T${data.BreakStart}:00`;
    };

    /** Combines BreakEndDateTime (YYYY-MM-DD string) + BreakEnd (HH:mm) into ISO datetime string */
    const buildBreakEndDateTime = (data) => {
        if (!data.BreakEndDateTime || !data.BreakEnd) return null;
        return `${data.BreakEndDateTime}T${data.BreakEnd}:00`;
    };

    const createPayload = (data, type) => {
        if (type === 'Edit') {
            return {
                IDDockBreak: data.breaksForWhOrDock !== 'Warehouse' ? (data.IDDockBreak || data.ID || null) : null,
                IDWHBreak: data.breaksForWhOrDock === 'Warehouse' ? data.IDWHBreak : null,
                IDWarehouse: data.IDWarehouse || whObj.ID,
                BreakStart: buildBreakStartDateTime(data),
                BreakEnd: buildBreakEndDateTime(data),
                Description: data.Description,
                Status: data.Status || 1,
                CreatedBy: data.CreatedBy || cu_id,
                UpdatedBy: cu_id,
                CreatedOn: data.CreatedOn,
                UpdatedOn: changeFormatWithoutTz(getCurrentDate(), AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                CRUDTYPE: 'U',
                BreakType: (data.breaksForWhOrDock || 'Docks').toUpperCase(),
                IDTimeslot: data.breaksForWhOrDock !== 'Warehouse' ? data.IDTimeslot : null,
                IDDock: data.breaksForWhOrDock !== 'Warehouse' ? data.IDDock : null,
                AppointmentCancelationType: 'MANUAL',
                ConflictAptStatus: false,
                operational_days: getOperationalDaysPayload(data)
            };
        } else {
            return {
                IDDockBreak: null,
                IDWHBreak: null,
                IDWarehouse: whObj.ID,
                BreakStart: buildBreakStartDateTime(data),
                BreakEnd: buildBreakEndDateTime(data),
                Description: data.Description,
                Status: 1,
                CreatedBy: cu_id,
                UpdatedBy: cu_id,
                CreatedOn: changeFormatWithoutTz(getCurrentDate(), AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                UpdatedOn: changeFormatWithoutTz(getCurrentDate(), AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                CRUDTYPE: 'I',
                BreakType: (data.breaksForWhOrDock || 'Docks').toUpperCase(),
                IDTimeslot: data.breaksForWhOrDock !== 'Warehouse' ? data.IDTimeslot : null,
                IDDock: data.breaksForWhOrDock !== 'Warehouse' ? data.IDDock : null,
                AppointmentCancelationType: 'MANUAL',
                ConflictAptStatus: false,
                operational_days: getOperationalDaysPayload(data)
            };
        }
    };

    const getSummitedFormData = (formData) => {
        setLoading(true);
        let apiParams = {};
        const operationObj = { type: '', status: '' };

        const isEditMode = Boolean(formData.IDDockBreak || formData.IDWHBreak || formData.ID);

        if (isEditMode) {
            const apiTempParams = createPayload(formData, 'Edit');
            operationObj.type = 'Edit Break';
            apiParams = { ...formData, ...apiTempParams };
        } else {
            apiParams = createPayload(formData, 'Create');
            operationObj.type = 'Add Break';
        }

        setPendingBreakData({ apiParams, operationObj, breaksForWhOrDock: formData.breaksForWhOrDock || 'Docks' });

        if (formData.breaksForWhOrDock === 'Warehouse') {
            dispatch({ type: sagaActions.WAREHOUSE_META_BREAKS_LIST_ACTION, payload: apiParams, operationObj: operationObj });
        } else {
            dispatch({ type: sagaActions.WAREHOUSE_META_DOCKS_BREAKS_LIST_ACTION, payload: apiParams, operationObj: operationObj });
        }
    };

    const createForm = () => {
        const isEdit = Object.keys(editData).length > 0;
 const daysInRange = getDaysInRange(inputs.BreakStartDateTime, inputs.BreakEndDateTime);

        return (
            <div className="container-fluid py-2">
                <div className="row gy-2">
                    {/* Break Type Selection */}
                    <div className="col-sm-12 mt-2 hidden">
                        <label className="form-label">Select for:</label>
                        <div className="radioButtonText d-flex form-check form-check-inline gap-5">
                            <label className="form-check-label">
                                <input
                                    type="radio"
                                    className="form-check-input"
                                    name="breaksForWhOrDock"
                                    value="Docks"
                                    checked={inputs.breaksForWhOrDock === 'Docks'}
                                    onChange={(e) => handleChange(e.target.value, 'breaksForWhOrDock')}
                                />
                                Docks
                            </label>
                        </div>
                    </div>

                    {/* Dock Selection */}
                    {!isDockHidden && (
                        <div className="col-sm-12">
                            <label className="form-label">
                                Dock<span className="color-red">*</span>
                            </label>
                            <select
                                className={`customSelect ${dirty.IDDock && errors.IDDock ? 'is-invalid' : ''}`}
                                value={inputs.IDDock}
                                onChange={(e) => handleChange(e.target.value, 'IDDock')}
                                onBlur={() => handleErrors('IDDock')}
          disabled={isEdit}
                            >
                                <option value="">Select Dock</option>
                                {getDockList()}
                            </select>
                            {dirty.IDDock && errors.IDDock && (
                                <span className="errorMessage d-block">{errors.IDDock}</span>
                            )}
                        </div>
                    )}

                    {/* Timeslot Selection */}
                    {!isTimeSlotHidden && (
                        <div className="col-sm-12">
                            <label className="form-label">
                                Timeslot<span className="color-red">*</span>
                            </label>
                            <select
                                className={`customSelect ${dirty.IDTimeslot && errors.IDTimeslot ? 'is-invalid' : ''}`}
                                value={inputs.IDTimeslot}
                                onChange={(e) => handleChange(e.target.value, 'IDTimeslot')}
                                onBlur={() => handleErrors('IDTimeslot')}
                            >
                                <option value="">Select Timeslot</option>
                                {timeSlotOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                            {dirty.IDTimeslot && errors.IDTimeslot && (
                                <span className="errorMessage d-block">{errors.IDTimeslot}</span>
                            )}
                        </div>
                    )}

                    {/* Break Start Date — native date input (supports typing + calendar) */}
                    <div className="col-sm-6 mt-2">
                        <label className="form-label">
                            Break Start Date<span className="color-red">*</span>
                        </label>
                           <input
                        key={`BreakStartDateTime-${dateResetKey}`}
                            type="date"
                          className={`customTextInput w-100 ${dirty.BreakStartDateTime && errors.BreakStartDateTime ? 'customError' : ''}`}
                               value={inputs.BreakStartDateTime || ''}
                             min={todayStr}
                          max="9999-12-31"
                                onChange={(e) => handleChange(e.target.value, 'BreakStartDateTime', e.target.validity)}
                     onBlur={(e) => handleErrors('BreakStartDateTime', e.target.validity)}
                            />
                        {dirty.BreakStartDateTime && errors.BreakStartDateTime && (
                            <span className="errorMessage d-block">{errors.BreakStartDateTime}</span>
                        )}
                    </div>

                    {/* Break End Date — native date input (supports typing + calendar) */}
                    <div className="col-sm-6 mt-2">
                        <label className="form-label">
                            Break End Date<span className="color-red">*</span>
                        </label>
                   <input
                              key={`BreakEndDateTime-${dateResetKey}`}
                      type="date"
                      className={`customTextInput w-100 ${dirty.BreakEndDateTime && errors.BreakEndDateTime ? 'customError' : ''}`}
                         value={inputs.BreakEndDateTime || ''}
                      min={inputs.BreakStartDateTime || todayStr}
                            max="9999-12-31"
                                onChange={(e) => handleChange(e.target.value, 'BreakEndDateTime', e.target.validity)}
                              onBlur={(e) => handleErrors('BreakEndDateTime', e.target.validity)}
                      />
                        {dirty.BreakEndDateTime && errors.BreakEndDateTime && (
                            <span className="errorMessage d-block">{errors.BreakEndDateTime}</span>
                        )}
                    </div>

                    {/* Start Time */}
                    <div className="col-sm-6 mt-2">
                        <label className="form-label">
                            {AppConstant.smartScheduler.breaksForm.tableHeaders.startTime}
                            <span className="color-red">*</span>
                        </label>
                        <select
                            className={`customSelect ${dirty.BreakStart && errors.BreakStart ? 'is-invalid' : ''}`}
                            value={inputs.BreakStart}
                            onChange={(e) => handleChange(e.target.value, 'BreakStart')}
                            onBlur={() => handleErrors('BreakStart')}
                        >
                            <option value="">Select Start Time</option>
                            {generateTimeOptions().map((time) => (
                                <option key={time} value={time}>{time}</option>
                            ))}
                        </select>
                        {dirty.BreakStart && errors.BreakStart && (
                            <span className="errorMessage d-block">{errors.BreakStart}</span>
                        )}
                    </div>

                    {/* End Time */}
                    <div className="col-sm-6 mt-2">
                        <label className="form-label">
                            {AppConstant.smartScheduler.breaksForm.tableHeaders.endTime}
                            <span className="color-red">*</span>
                        </label>
                        <select
                            className={`customSelect ${dirty.BreakEnd && errors.BreakEnd ? 'is-invalid' : ''}`}
                            value={inputs.BreakEnd}
                            onChange={(e) => handleChange(e.target.value, 'BreakEnd')}
                            onBlur={() => handleErrors('BreakEnd')}
                        >
                            <option value="">Select End Time</option>
                            {getFilteredEndTimes().map((time) => (
                                <option key={time} value={time}>{time}</option>
                            ))}
                        </select>
                        {dirty.BreakEnd && errors.BreakEnd && (
                            <span className="errorMessage d-block">{errors.BreakEnd}</span>
                        )}
                    </div>

                    {/* Operational Days Checkboxes */}
                    {!isDockHidden && selectedDockData && (
                        <div className="col-sm-12">
                            <label className="form-label">
                                Select Break Days:
                                {daysInRange && (
                                    <span className="ms-1 f-10 text-muted">
                                        (Showing dock operational days within selected date range)
                                    </span>
                                )}
                            </label>
                            <div className={`d-flex flex-wrap gap-3 ${dirty.operational_days && errors.operational_days ? 'is-invalid' : ''}`}>
                                {selectedDockData.sunday && (!daysInRange || daysInRange.sunday) && (
                                    <label className="form-check-label">
                                        <input type="checkbox" className="form-check-input" name="sunday"
                                            checked={operationalDays.sunday || false}
                                            onChange={handleOperationalDays}
                                            onBlur={() => handleErrors('operational_days')} />
                                        Sunday
                                    </label>
                                )}
                                {selectedDockData.monday && (!daysInRange || daysInRange.monday) && (
                                    <label className="form-check-label">
                                        <input type="checkbox" className="form-check-input" name="monday"
                                            checked={operationalDays.monday || false}
                                            onChange={handleOperationalDays}
                                            onBlur={() => handleErrors('operational_days')} />
                                        Monday
                                    </label>
                                )}
                                {selectedDockData.tuesday && (!daysInRange || daysInRange.tuesday) && (
                                    <label className="form-check-label">
                                        <input type="checkbox" className="form-check-input" name="tuesday"
                                            checked={operationalDays.tuesday || false}
                                            onChange={handleOperationalDays}
                                            onBlur={() => handleErrors('operational_days')} />
                                        Tuesday
                                    </label>
                                )}
                                {selectedDockData.wednesday && (!daysInRange || daysInRange.wednesday) && (
                                    <label className="form-check-label">
                                        <input type="checkbox" className="form-check-input" name="wednesday"
                                            checked={operationalDays.wednesday || false}
                                            onChange={handleOperationalDays}
                                            onBlur={() => handleErrors('operational_days')} />
                                        Wednesday
                                    </label>
                                )}
                                {selectedDockData.thursday && (!daysInRange || daysInRange.thursday) && (
                                    <label className="form-check-label">
                                        <input type="checkbox" className="form-check-input" name="thursday"
                                            checked={operationalDays.thursday || false}
                                            onChange={handleOperationalDays}
                                            onBlur={() => handleErrors('operational_days')} />
                                        Thursday
                                    </label>
                                )}
                                {selectedDockData.friday && (!daysInRange || daysInRange.friday) && (
                                    <label className="form-check-label">
                                        <input type="checkbox" className="form-check-input" name="friday"
                                            checked={operationalDays.friday || false}
                                            onChange={handleOperationalDays}
                                            onBlur={() => handleErrors('operational_days')} />
                                        Friday
                                    </label>
                                )}
                                {selectedDockData.saturday && (!daysInRange || daysInRange.saturday) && (
                                    <label className="form-check-label">
                                        <input type="checkbox" className="form-check-input" name="saturday"
                                            checked={operationalDays.saturday || false}
                                            onChange={handleOperationalDays}
                                            onBlur={() => handleErrors('operational_days')} />
                                        Saturday
                                    </label>
                                )}
                            </div>
                            {dirty.operational_days && errors.operational_days && (
                                <span className="errorMessage d-block">{errors.operational_days}</span>
                            )}
                        </div>
                    )}

                    {/* Description */}
                    <div className="col-sm-12">
                        <label className="form-label">
                            Description<span className="color-red">*</span>
                        </label>
                        <textarea
                            className={`form-control ${dirty.Description && errors.Description ? 'is-invalid' : ''}`}
                            value={inputs.Description}
                            onChange={(e) => handleChange(e.target.value, 'Description')}
                            onBlur={() => handleErrors('Description')}
                            rows="3"
                        />
                        {dirty.Description && errors.Description && (
                            <span className="errorMessage d-block">{errors.Description}</span>
                        )}
                    </div>
                </div>

                {/* Form Buttons */}
                <div className="d-flex justify-content-end marbt-10 mt-3 gap-2">
                    <button type="button" className="btn-unstyled light-mode" onClick={resetForm} disabled={loading}>
                        {AppConstant.comments.resetbutton}
                    </button>
                    <button type="button" className="btn-styled light-mode" onClick={submitForm} disabled={loading}>
                        {loading ? (
                            <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> Loading...</>
                        ) : (
                            AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm.saveButtonTitle
                        )}
                    </button>
                </div>
            </div>
        );
    };

    const closeCurrentpopup = () => {
        resetForm();
        setShowModal(false);
    };

    const showCreateBreakPopup = () => {
        const popupObj = {
            id: 'createCompanyGroupFormPopup1',
            modalLabel: 'createCompanyGroupFormPopup1',
            showClose: true,
            showfooter: false,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: Object.keys(editData).length ? AppConstant.smartScheduler.breaksForm.editBreakTitle : AppConstant.smartScheduler.breaksForm.createBreakTitle,
            bodyText: createForm(),
            subText: '',
            keyboard: false,
            backdrop: 'static',
            footerBtn: {
                btn1: { show: true, text: AppConstant.comments.cancelCommentButtonTitle },
                btn2: { show: true, text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm.saveButtonTitle }
            }
        };
        return <SSPopup {...popupObj} popupBtnHandler={(text) => () => ''} closepopup={closeCurrentpopup} themeSelected={themeSelected} showModal={showModal} />;
    };

    const openCreateForm = () => {
        resetForm();
        fetchDockList();
        fetchTimeslotList();
        setShowModal(true);
    };

    const showCustomDropDownForFilters = () => {
        const filterDataArr = [{ name: 'Docks' }, { name: 'Timeslot' }];
        return (
            <div className="d-flex align-items-center">
                <CustomDropDownSS themeSelected={themeSelected} data={filterDataArr} placeHolder={currentFilterSelected?.name} onSelect={(event) => setCurrentFilterSelected(event)} keyStr={'name'} />
            </div>
        );
    };

    const closePreCheckpopup = () => {
        setShowPreCheckModal(false);
    };

    const popupBtnHandler = (text) => {
        if (text === AppConstant.commonStrings.viewDetailsStr) {
            navigate('/manageappointments');
        } else {
            setShowPreCheckModal(false);
        }
    };

    const handleDisableBreakWithPreCheck = (apiParams, operationObj) => {
        setPendingBreakData({ apiParams, operationObj, breaksForWhOrDock: 'Docks' });
        dispatch({ type: sagaActions.WAREHOUSE_META_DOCKS_BREAKS_LIST_ACTION, payload: apiParams, operationObj: operationObj });
    };

    const showPreCheck = () => {
        const popupObj = {
            id: 'adminUpdateOperationPreCheck',
            modalLabel: 'adminUpdateOperationPreCheck',
            showClose: true,
            showfooter: true,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: AppConstant.smartScheduler.leaves.apptConflict,
            bodyText: AppConstant.superUserAdmin.warehouseAdmin.preCheckBockerMsg,
            subText: '',
            keyboard: false,
            backdrop: 'static',
            footerBtn: {
                btn1: { show: true, text: AppConstant.commonStrings.viewDetailsStr },
                btn2: { show: false }
            }
        };
        return <SSPopup {...popupObj} popupBtnHandler={(text) => { popupBtnHandler(text); }} closepopup={() => { closePreCheckpopup(); }} themeSelected={themeSelected} showModal={showPreCheckModal} />;
    };

    const handleAutomaticCancelConfirm = (selectedReason, excludedAppointments) => {
        setLoading(true);
        const { apiParams, operationObj, breaksForWhOrDock } = pendingBreakData;
        // If selectedReason is null, all appointments were excluded - skip cancellation, still save the break
        const allExcluded = !selectedReason;
        const newApiParams = {
            ...apiParams,
            ConflictAptStatus: !allExcluded,
            AppointmentCancelationType: allExcluded ? null : 'AUTOMATIC',
            Reason: allExcluded ? null : selectedReason,
            ExcludedAppointments: !allExcluded && excludedAppointments && excludedAppointments.length ? excludedAppointments.toString() : null
        };
        // When all appointments are excluded, mark confirm=true so the saga skips the pre-check
        // and proceeds directly to saving the break (avoids re-triggering showPreCheckModal).
        const newOperationObj = allExcluded ? { ...operationObj, confirm: true } : operationObj;
        dispatch({ type: sagaActions.UPDATE_PRE_CHECK_LIST, payload: [] });

        if (breaksForWhOrDock === 'Warehouse') {
            dispatch({ type: sagaActions.WAREHOUSE_META_BREAKS_LIST_ACTION, payload: newApiParams, operationObj: newOperationObj });
        } else {
            dispatch({ type: sagaActions.WAREHOUSE_META_DOCKS_BREAKS_LIST_ACTION, payload: newApiParams, operationObj: newOperationObj });
        }
        setPendingBreakData(null);
        if (!allExcluded) {
            setShowAutoMassCancelNotification(true);
        }
    };

    const showAutomaticCancelPopup = () => {
        if (!showAutomaticCancelConfirmPopup) return null;

        const popupBodyText = `You have scheduled a break from ${moment(pendingBreakData?.apiParams?.BreakStart).tz(moment.tz.guess()).format('MM/DD/YYYY HH:mm')} to ${moment(pendingBreakData?.apiParams?.BreakEnd).tz(moment.tz.guess()).format('MM/DD/YYYY HH:mm')}. There ${_.uniqBy(preCheckList, 'PORelationID').length === 1 ? 'is ' : 'are '} ${_.uniqBy(preCheckList, 'PORelationID').length} appointments already scheduled for the following time slot(s):`;

        return (
            <AutomaticCancelPopup
                themeSelected={themeSelected}
                showPopup={showAutomaticCancelConfirmPopup}
                setShowPopup={setShowAutomaticCancelConfirmPopup}
                pendingData={pendingBreakData}
                setPendingData={setPendingBreakData}
                whObj={whObj}
                onProceed={handleAutomaticCancelConfirm}
                popupTitle="Confirm Break"
                popupBodyText={popupBodyText}
                cuid={cu_id}
                showCheckboxes={true}
            />
        );
    };

    return (
        <div>
            <div className='container-fluid d-flex py-2 text-start justify-content-between mt-1 w-100'>
                <button
                    className={'btn-highlighted f-12'}
                    data-bs-toggle="modal"
                    onClick={() => openCreateForm()}
                >
                    {AppConstant.smartScheduler.breaksForm.createBreakTitle}
                </button>
                <div className='d-flex w-50 justify-content-end'>
                    <div className='ms-5'>
                        <WarehouseSearchSS
                            placeholder={'Search Breaks'}
                            inputValue={searchStr}
                            cancelSearch={() => setSearchStr('')}
                            onChangeHandler={(text) => setSearchStr(text)} />
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-center breaksMetaList">
                <BreaksMetaListSS currentFilterSelected={currentFilterSelected} whObj={whObj} {...props} searchStr={searchStr} editBreakAction={(groupObj) => editBreak(groupObj)} showPopup={() => showCreateBreakPopup()} themeSelected={themeSelected} allowPermissionE={allowPermissionE} allowPermissionD={allowPermissionD} whMetaDocksList={whMetaDocksList} handleDisableBreakWithPreCheck={handleDisableBreakWithPreCheck} />
                {showCreateBreakPopup()}
                {showPreCheck()}
                {showAutomaticCancelPopup()}
            </div>
        </div>
    );
};

export default BreaksMetaDataFormSS;
